import { orderBy } from 'lodash'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { SuggestedTradeView } from 'enums/SuggestedTradeView'
import { PortfolioSuggestedTrade, PortfolioSuggestedTradeFull } from 'types'

import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSControlGroup from 'designSystem/components/PDSControlGroup/PDSControlGroup'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSHeader from 'designSystem/components/PDSHeader/PDSHeader'
import { SIZE } from 'designSystem/foundations/constants/size'

import PortfolioSuggestedTradesListItem from './PortfolioSuggestedTradesListItem'

type Props = {
  portfolioId?: string
  suggestedTrades: PortfolioSuggestedTradeFull[]
  title?: string
}

type ViewTypeOption = {
  label: string
  value: SuggestedTradeView
}

const OPTIONS: ViewTypeOption[] = [
  { value: SuggestedTradeView.PERCENTAGE, label: 'Percentage' },
  { value: SuggestedTradeView.SHARE, label: 'Share' },
  { value: SuggestedTradeView.VALUE, label: 'Value' },
  { value: SuggestedTradeView.GAIN, label: 'Gain' },
]

const sortByKey: Record<SuggestedTradeView, keyof PortfolioSuggestedTrade> = {
  [SuggestedTradeView.PERCENTAGE]: 'recommendedWeight',
  [SuggestedTradeView.SHARE]: 'shares',
  [SuggestedTradeView.VALUE]: 'value',
  [SuggestedTradeView.GAIN]: 'realizedGain',
}

const actionSortOrderByView: Record<SuggestedTradeView, 'asc' | 'desc'> = {
  [SuggestedTradeView.PERCENTAGE]: 'asc',
  [SuggestedTradeView.SHARE]: 'asc',
  [SuggestedTradeView.VALUE]: 'asc',
  [SuggestedTradeView.GAIN]: 'desc',
}

export default function PortfolioSuggestedTradesList({
  portfolioId,
  suggestedTrades,
  title,
}: Props) {
  const [tradeView, setTradeView] = useState<SuggestedTradeView>(
    SuggestedTradeView.PERCENTAGE
  )
  const navigate = useNavigate()

  const sortedTrades = orderBy(
    suggestedTrades,
    ['action', sortByKey[tradeView]],
    [actionSortOrderByView[tradeView], 'desc']
  )

  const onAssetClick = (symbol: string) => {
    navigate(`/asset/${symbol}?portfolioId=${portfolioId}`)
  }

  return (
    <PDSBox marginTop={SIZE.s32}>
      <PDSHeader variant="h4">
        {title} ({suggestedTrades?.length})
      </PDSHeader>
      <PDSBox marginTop={SIZE.s8}>
        <PDSControlGroup
          defaultValue={SuggestedTradeView.PERCENTAGE}
          label="View As"
          mainOnClick={(option: any) => setTradeView(option.value)}
          options={OPTIONS}
        />
      </PDSBox>
      <PDSFlexBox flexDirection="column" gap={SIZE.s8} marginTop={SIZE.s24}>
        {sortedTrades.map((trade, i) => {
          return (
            <PortfolioSuggestedTradesListItem
              key={`suggested-trade-item-${trade.symbol}-${i}`}
              onAssetClick={() => onAssetClick(trade.symbol)}
              trade={trade}
              tradeView={tradeView}
            />
          )
        })}
      </PDSFlexBox>
    </PDSBox>
  )
}
